<div>
    <app-mentornavbar></app-mentornavbar>
</div>
<div class="body">
    <div class="centerdiv">
        <div class="image">
            <img src="../../../assets/images/eureka_sponsor.png" alt="">
        </div>
        <div class="buttons">
            <a routerLink="/zonallogin"><button class="btn btn-lg inverse">Find your Mentor</button></a>
        </div>
    </div>
</div>
<div class="howworks">
    <h1>How it Works?</h1>
    <h2>Steps by Steps</h2>
    <div class="steps">
        <div class="step">
            <p>
                Browse our community of experts to find the right one for you
            </p>
        </div>
        <div class="step">
            <p>
                At this time, you will be pre-charged for the estimated length of the call, based on the expert's per-minute rate.
            </p>
        </div>
        <div class="step">
            <p>
                Call the conference line provided. After the call, the charge will be adjusted to reflect the actual length of the call.
            </p>
        </div>
    </div>
</div>
<div class="footer" style="background: black;">
    <app-footer></app-footer>
</div>